
namespace GeniuzPOS.ReportMasterData {
    import fld = Report_1302Row.Fields;
    // import DocDaterequest = GeniuzPOS.ReportMasterData.DocDaterequest;
    @Serenity.Decorators.registerClass()
    export class Report_1302Grid extends Serenity.EntityGrid<Report_1302Row, any> {        
        protected getColumnsKey() { return Report_1302Columns.columnsKey; }
        protected getDialogType() { return Report_1302Dialog; }
        protected getIdProperty() { return Report_1302Row.idProperty; }
        protected getInsertPermission() { return Report_1302Row.insertPermission; }
        protected getLocalTextPrefix() { return Report_1302Row.localTextPrefix; }
        protected getService() { return Report_1302Service.baseUrl; }

        public _afromDate: string;
        public _aendDate: string;

        private _orderNo: string
        public get OrderNo(): string { return this._orderNo; }
        
        
// ตัวอย่าง
        // จาก
        // const dialog = new PsAdvPromoItemExemptDialog()
            //         dialog.PmId = this.form.PmId.value,
            
        // public get PmId(): string { return this._PmId }
        // set PmId(value: string) {
        //     this._PmId = value;
        //     this.form.PmId.value = this._PmId
        // }
        // public get PmGroupId(): string { return this._pmGroupId }
        // set PmGroupId(value: string) { this._pmGroupId = value }

        public get _fromDate(): string { return this._afromDate }
        //set _fromDate(value: string) { this._afromDate = value }
        // get _endDate(): string { return Report_1302Grid._endDate }
        // set _endDate(value: string) { Report_1302Grid._endDate = value }
        

        constructor(container: JQuery) {
            super(container);
        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            // let columns = Object.keys(options.columnStyles)
            // let p = Serenity.GridRowSelectionMixin

            //ทดสอบ เรียกuser -- ยังไม่สำเร็จ  
            // var username = Authorization.userDefinition.Username;
            // var userId = Q.tryFirst(Administration.UserRow.getLookup().items, x => x.Username == Authorization.userDefinition.Username);
            // //var Plucheck = (Inventory.IcStockTranRow.getLookup().items, x => x.SkuCode == this.entity.SkuCode);
            // var idd = Q.first(QRreport.QRywcSpecRow.getLookup().items,x => x.ReportId == '1302')
            // // var btnConfirm = userId.ButtonsConfirm
            // console.log('Username : ' + username );
            // console.log(idd);

            // let el = document.querySelector('form[id*=QRywcSpecDialog]');
            // let input: HTMLInputElement = el.querySelector('input[name="FBranchCode"]');


            let descriptions: string[] = [];

            // Q.first(QRreport.QRywcSpecRow.getLookup().items, x=> x.CreateBy == Authorization.userDefinition.Username)
                //สิ่งที่ได้จากQนี้คืออะไร
            let shop = QRreport.QRywcSpecRow.getLookup().itemById["2"].ShopId;
            // let shop = Q.first(QRreport.QRywcSpecRow.getLookup().items, x => x.ShopId== "2" && x.CashierId).ShopId;
            let pos = QRreport.QRywcSpecRow.getLookup().itemById["2"].PosId;
            let startDate = QRreport.QRywcSpecRow.getLookup().itemById["2"].DateBegin;
            let endDate = QRreport.QRywcSpecRow.getLookup().itemById["2"].DateEnd;
            let qstartDate =Q.formatDate(startDate, "dd/MM/yyyy")
            let qendDate =Q.formatDate(endDate, "dd/MM/yyyy")
            var a = ""
            if (shop != null) {
                
                a = "ระหว่างวันที่ " +qstartDate +" - " +qendDate+ "   ระบุร้านค้า รหัส"+shop
                
            } else
            {
                shop = "ไม่ระบุ"
                a = "ระหว่างวันที่ " +qstartDate +" - " +qendDate 
                
            }
            var b =""

            if (pos != null) {

                b = a + "ระบุPOS รหัส"+pos
                
            } else
            {
                
                b = a
                
            }
            descriptions.push(b);



            // console.log(request)
            // if (request?.Criteria) {
            //     let criteria = request.Criteria.toString().split(',');
            //     let key: string = criteria[0];

            //     let n = columns.find(n => {
            //         return options.columnStyles[n]['field'] === key
            //     });
            //     if (n) {
            //         key = options.columnStyles[n]['title'];
            //     }

            //     let d1 = criteria.findIndex(c => c == ">=");
            //     if (d1 >= 0) {
            //         let v1 = criteria[d1 + 1];
            //         let d2 = criteria.findIndex(c => c == "<");

            //         if (d2 >= 0) {
            //             let v2 = criteria[d2 + 1];

            //             descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy" + ' (00:00)')}  -  ${Q.formatDate(v2, "dd/MM/yyyy" + ' (00:00)')}`);

            //         } else {
            //             descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy")}`);
            //         }
            //     } else {
            //         let d2 = criteria.findIndex(c => c == "<");
            //         if (d2 >= 0) {
            //             let v2 = criteria[d2 + 1];
            //             descriptions.push(`${key} ถึง  ${Q.formatDate(v2, "dd/MM/yyyy")}`);
            //         }
            //     }
            // } else {
            //     descriptions.push("วันที่ = ไม่ระบุ");
            //     // let d = QRreport.QRywcSpec1302Dialog
            //     // descriptions.push("วันที่ = "+ Report_1302Grid._fromDate +" - " + Report_1302Grid._endDate);
            //     // console.log(Report_1302Grid._fromDate)
            //     // console.log(d._dfromDate)

            // }


            // // console.log(request)
            // if (request?.EqualityFilter) {
            //     let quickFilters = this.getQuickFilters();

            //     let filters = Object.keys(request.EqualityFilter);

            //     for (let filterCol of filters) {
            //         let quickFilter = Q.first(quickFilters, x => x.field === filterCol);
            //         let filterValue = request.EqualityFilter[filterCol];
            //         // if else{
            //         if (filterValue.length > 0) {
            //             if (Array.isArray(filterValue)) {
            //                 if (quickFilter.options.lookupKey) {
            //                     // console.log(filterValue);
            //                     (filterValue as any[]).forEach(value => {
            //                         var names: string[] = new Array(filterValue);
            //                         for (var i = 0; i < names.length; i++) {
            //                             filterValue = (names[i]);
            //                             console.log(filterValue);
            //                         }
            //                     })

            //                 }
            //             } else {
            //                 filterValue
            //             }
            //         }
            //         else {
            //             filterValue = "ไม่ระบุ"
            //         }
            //         // }

            //         let n = columns.find(n => {
            //             return options.columnStyles[n]['field'] === filterCol
            //         });
            //         if (n) {
            //             descriptions.push(`${options.columnStyles[n]['title']} = ${filterValue}`)
            //         }
            //     }
            // }
            return [descriptions, gridColumns];
        }

        protected createQuickSearchInput() {
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["ShopId"]);
            // groupingMixin.plugin.setDroppedGroups(["PosId"]);

        }
        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);
        }
        protected getItemCssClass(item: GeniuzPOS.ReportMasterData.Report_1302Row, index: number): string {
            let css = '';

            // if (item.Quantity < 0) {
            //     css += ' bg-danger text-white';
            // }

            return Q.trimToNull(css);
        }


        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_1302Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            let reportTitle = 'รายงานยอดขายตามสรุปร้านค้า&เครื่อง POS(Sales summary by shop&POS id.)'

            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "ShopName", title: "ร้านค้า", cellWidth: 42, overflow: 'linebreak', isHidden: true },
                1: { field: "DocDate", title: "วันที่", cellWidth: 67 ,isHidden: true},
                2: { field: "PosId", title: "เครื่องPOS", cellWidth: 20, isHidden: true },
                3: { field: "ShopId", title: "ร้านค้า", cellWidth: 20, isHidden: true },
                4: { field: "GrossSales", title: "ยอดขายก่อนลด", cellWidth: 40, halign: 'right', aggregate: "sum" },
                5: { field: "AllItemDiscount", title: "ยอดส่วนลดทั้งหมด", cellWidth: 40, halign: 'right', aggregate: "sum" },
                6: { field: "NetSales", title: "ยอดขายสุทธิ", cellWidth: 40, halign: 'right', aggregate: "sum" },
                7: { field: "NetSalesExVat", title: "ยข. สุทธิหักVAT", cellWidth: 40, halign: 'right', aggregate: "sum" },
                8: { field: "VatOfNetSales", title: "VAT(ยอดขาย)", cellWidth: 40, halign: 'right', aggregate: "sum" },
                9: { field: "AllItemCharge", title: "ต่าชาร์จ", cellWidth: 40, halign: 'right', aggregate: "sum" },
                10: { field: "VatOfCharge", title: "VAT(ค่าชาร์จ)", cellWidth: 40, halign: 'right', aggregate: "sum" },
            }

            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {

            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            //     // didParseCell: (data) => {
            //     //     if (data.section === 'body') {
            //     //         var qty = parseInt(data.row.raw[3]);
            //     //         if (isNaN(qty) === false && qty < 0) {
            //     //             data.cell.styles.textColor = 'red';
            //     //         }
            //     //     }
            //     // }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),

            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {

            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpec1302/edit/2';
                        return false;
                    },
                }
            );
            return buttons;
        }

        // protected getQuickFilters() {
        //     var filters = super.getQuickFilters();

        //     Q.first(filters, x => x.field == fld.DocDate).init = w => {

        //         (w as Serenity.DateEditor).valueAsDate = new Date(Date.now());
        //         this._fromDate = (w as Serenity.DateEditor).valueAsDate
        //         let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
        //         endDate.valueAsDate = new Date(Date.now());
        //         this._endDate = endDate.valueAsDate
        //     };


        //     return filters;
        // }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            let ele = document.getElementsByClassName("grid-container");
            var bordermg = 60;
            var eleWidth = ele.item(0).clientWidth - bordermg * 5;
            var totalcolw = 0;
           
            let propItems = this.getPropertyItems();
            let items = this.getColumns();
           items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                totalcolw += pItem.width;

            });
            items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                pItem.resizable = true;
                pItem.width = (eleWidth / totalcolw) * pItem.width;


            });
           
            let c = this.postProcessColumns(this.propertyItemsToSlickColumns(propItems));
            grid.setColumns(c);
            grid.resizeCanvas();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [

                    new Slick.Aggregators.Sum('GrossSales'),
                    new Slick.Aggregators.Sum('AllItemDiscount'),
                    new Slick.Aggregators.Sum('NetSales'),
                    new Slick.Aggregators.Sum('NetSalesExVat'),
                    new Slick.Aggregators.Sum('NetSalesNonVat'),
                    new Slick.Aggregators.Sum('VatOfNetSales'),
                    new Slick.Aggregators.Sum('VatOfCharge'),
                    new Slick.Aggregators.Sum('AllItemCharge')
                ]
            });
            this.view.setGrouping([
                {
                    getter: 'FullName',
                    formatter: function (g) {
                        return g.value.toString();
                    }
                },

                {
                    getter: 'PosId',
                    formatter: function (g) {
                        return g.value.toString();
                    }
                }
            ])

            return grid;
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            opt.groupingPanel = true;
            return opt;
        }
        

    

    }
}